export const orderModule = {
    cancel: "取消",
    pay: "支付",
    chose_pay_type:"請選擇支付方式",
    phone:"手機號",
    desc1:"将门票URL发送到以下手机号码或者Email",
    pay_title:"支付",
    to_pay:"去支付",
    agree:"同意",
    policy:"隱私政策",
    total:"合計",
    use_point:"利用景點",
    use_point_code:"使用時請掃二維碼",
    code:"對照碼",
    used_point:"已經利用的景點",
    more:"更多",
    input:"請填寫必要信息",
    pay_type:"請選擇支付方式",
    isCancel:"要取消嗎?",
    sure:"確定",
    pay_success:"感謝您的購買",
    pay_cancel:"成功取消",
    pay_fail:"支付失敗",
    pay_cancel1:"已取消",
    pay_wait:"支付結果等待中",
    status1:"等待支付",
    status2:"可以使用",
    status3:"已完成",
    status4:"已過期",
    status5:"已退款",
    status6:"取消",
    selectBookFun: "選擇方式",
    inputBookPlaceholder: "請輸入發票的擡頭",
    inputMemoPlaceholder: '請填寫備註',
    getBook: "發票擡頭",
    comment: "評論",
    comment_star: "滿足度",
    comment_contentHolder: "請留言",
    comment_noStar: "請選擇滿意度",
    comment_noContent: "評論內容不能為空",
    comment_submitSuccess: "評價成功",
    comment_replay: "商家回復",
    comment_uploadSuccess: "上傳成功",
    comment_moreImg: "最多可以上傳4張圖片",
    comment_sizeImg: "圖片不能大于5M",
};

export default orderModule;